import { FormCol, FormRow, TextareaControl } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface MessageRowProps { disabled?: boolean; autoFocus?: boolean }

const MessageRow: FC<MessageRowProps> = ({ disabled, autoFocus = false }) => {
  const { t } = useTranslation('MessageRow');

  return (
    <FormRow>
      <FormCol label={t('message')} labelMarginBottom={36}>
        <TextareaControl
          autoFocus={autoFocus}
          required
          name="message"
          disabled={disabled}
        />
      </FormCol>
    </FormRow>
  );
};

export default MessageRow;
